import { FC, useState } from 'react';
import { Agent } from 'src/types/agents.ts';
import { AgentTokenChart } from './AgentTokenChart.tsx';
import { HolderDistribution } from './HolderDistribution.tsx';
import { DexToolsChart } from './DexToolsChart.tsx';

const TABS = [
  { name: 'Chart', value: 'chart' },
  { name: 'Registry', value: 'registry' },
];

interface TabsProps {
  agent: Agent;
}

const renderTab = (tab: string, agent: Agent) => {
  switch (tab) {
    case 'chart':
      return agent.token_info?.uniswap_pair_address ? (
        <DexToolsChart agent={agent} />
      ) : (
        <AgentTokenChart agent={agent} />
      );
    case 'registry':
      return <HolderDistribution agent={agent} />;
    default:
      return null;
  }
};

export const Tabs: FC<TabsProps> = ({ agent }) => {
  const [currentTab, setCurrentTab] = useState<string>(TABS[0].value);

  function handleTabClick(tab: (typeof TABS)[number]) {
    setCurrentTab(tab.value);
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="mb-6 flex flex-grow flex-wrap gap-3">
        {TABS.map((el, index) => (
          <button
            type="button"
            key={index}
            className={`grow border-b-[2px] border-b-white px-3 py-2 text-xl ${
              el.value === currentTab ? 'text-white' : 'opacity-20'
            }`}
            onClick={() => handleTabClick(el)}
            aria-pressed={currentTab === el.value}
          >
            {el.name}
          </button>
        ))}
      </div>

      {renderTab(currentTab, agent)}
    </div>
  );
};
